import { Box, Button, FlexBox, Image, Text } from '@dixa/lib-shared-habla';

import CTAImage from 'images/copilot-trial/cta-image.png';
import { CopilotTrialStatus, useCopilotTrial } from 'utils/useCopilotTrial';
import { useCurrentUser } from 'utils/user';

const textContent = {
  [CopilotTrialStatus.Eligible]: {
    headings: [
      {
        props: {
          variant: 'heading-1',
          margin: '0 0 300',
        },
        content:
          'Introducing Agent Co-pilot: Elevate Your Team Support Experience with AI!',
      },
      {
        props: {
          variant: 'heading-2',
          margin: '0 0 200',
        },
        content: 'Unlock 30 days of trial: Empower your team to explore',
      },
    ],
    paragraphs: [
      {
        content:
          'Elevate your support team with our latest innovation, designed to streamline interactions and boost customer satisfaction.',
      },
    ],
  },
  [CopilotTrialStatus.TrialActive]: {
    headings: [
      {
        props: {
          variant: 'heading-3',
          margin: '0 0 400',
        },
        content: '🌟 Your Agent Copilot Trial is Now Active! 🌟',
      },
    ],
    paragraphs: [
      {
        content:
          "Ready to make Agent Copilot permanent? Request a contact from our team, and we'll reach out to you.",
      },
    ],
  },
  [CopilotTrialStatus.TrialExpired]: {
    headings: [
      {
        props: {
          variant: 'heading-1',
          margin: '0 0 300',
        },
        content: 'Transform Your Customer Support: Elevate Beyond the Trial',
      },
    ],
    paragraphs: [
      {
        props: {
          margin: '0 0 200',
        },
        content:
          "Your 30-day trial has ended—now is the moment to permanently enhance your customer support experience. Don't miss out on elevating your service to new heights.",
      },
      {
        content: "Request a contact from our team, and we'll reach out to you.",
      },
    ],
  },
};

export const CallToActionSection = (): JSX.Element => {
  const { status, startTrial, stopTrial, resetTrial, trialDaysLeft } =
    useCopilotTrial();
  const { user } = useCurrentUser();

  const trialDaysLeftText = trialDaysLeft
    ? `${trialDaysLeft} days remaining`
    : '';

  return (
    <FlexBox gap="400">
      <FlexBox flex="1 1 400px">
        <Box width="100%">
          <Image src={CTAImage} alt="Agent Co-pilot" />
        </Box>
      </FlexBox>
      <FlexBox
        flex="1 1 550px"
        flexDirection="column"
        background="purple.100"
        borderRadius="100"
        padding="400"
        justifyContent="space-between"
      >
        <FlexBox flexDirection="column">
          {textContent[status].headings.map((heading, i) => (
            <Text.Heading key={i} color="purple.600" {...heading.props}>
              {heading.content}
            </Text.Heading>
          ))}
          {trialDaysLeftText && (
            <Text.Heading
              variant="heading-1"
              color="purple.600"
              margin="0 0 400"
            >
              {trialDaysLeftText}
            </Text.Heading>
          )}
          {textContent[status].paragraphs.map((paragraph, i) => (
            <Text.Paragraph key={i} {...paragraph.props}>
              {paragraph.content}
            </Text.Paragraph>
          ))}
        </FlexBox>
        <FlexBox gap="200" margin="300 0 0">
          {status === CopilotTrialStatus.Eligible && (
            <Button onClick={startTrial}>Start trial for all agents</Button>
          )}
          {status === CopilotTrialStatus.TrialActive && (
            <>
              <Button onClick={() => {}}>Ask for contact</Button>
              <Button onClick={stopTrial} variant="tertiary">
                Stop trial
              </Button>
            </>
          )}
          {status === CopilotTrialStatus.TrialExpired && (
            <Button onClick={() => {}}>Request contact</Button>
          )}
          {user.email?.endsWith('@dixa.com') && (
            <Button icon="dixa" onClick={resetTrial} variant="danger">
              Reset trial
            </Button>
          )}
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
};
